/*
 * Konfigurátor služby.
 *
 * Cenu tady jen ZOBRAZUJEME. Do košíku se posílají výhradně dvojice
 * varianta + množství, takže výslednou částku určí Shopify. Kdyby si někdo
 * pohrál s hodnotami v prohlížeči, na zaplacenou částku to nemá vliv.
 */
(function () {
  'use strict';

  /* Formátování měny podle nastavení obchodu. Pokrývá tokeny, které Shopify
     pro české koruny reálně používá. */
  function moneyFormatter(format) {
    function group(cents, decimals, thousands, decimal) {
      var value = (cents / 100).toFixed(decimals);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? parts.join(decimal) : parts[0];
    }
    return function (cents) {
      var out = String(format || '{{amount}}');
      return out.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount': return group(cents, 2, ',', '.');
          case 'amount_no_decimals': return group(cents, 0, ',', '');
          case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', '');
          case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', '');
          case 'amount_with_apostrophe_separator': return group(cents, 2, '’', '.');
          default: return group(cents, 0, ' ', '');
        }
      });
    };
  }

  function init(root) {
    if (root.dataset.svcInit) return;
    root.dataset.svcInit = '1';

    var mode = root.dataset.mode || 'items';
    var minTotal = parseInt(root.dataset.minTotal, 10) || 0;
    var topupId = root.dataset.topupId ? parseInt(root.dataset.topupId, 10) : 0;
    var topupPrice = parseInt(root.dataset.topupPrice, 10) || 0;
    var money = moneyFormatter(root.dataset.moneyFormat);

    /* Texty hlášek pro aktuální jazyk posílá sekce v atributech data-t-*
       (jazykové soubory, klíče dmp.svc.*). Český text je záloha, kdyby atribut chyběl. */
    function tr(key, fallback) {
      var value = root.dataset[key];
      return value ? value : fallback;
    }

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var countInput = root.querySelector('[data-count]');
    var zoneSelect = root.querySelector('[data-zone]');
    var pscInput = root.querySelector('[data-psc]');
    var addrInput = root.querySelector('[data-addr]');
    var dateInput = root.querySelector('[data-date]');
    var noteInput = root.querySelector('[data-note]');
    var phoneInput = root.querySelector('[data-phone]');

    var addBtn = root.querySelector('[data-add]');
    var enquiryLink = root.querySelector('[data-enquiry-link]');
    var msg = root.querySelector('[data-msg]');

    var sumWork = root.querySelector('[data-sum-work]');
    var sumWorkVal = root.querySelector('[data-sum-work-value]');
    var sumTopup = root.querySelector('[data-sum-topup]');
    var sumTopupVal = root.querySelector('[data-sum-topup-value]');
    var sumTransport = root.querySelector('[data-sum-transport]');
    var sumTransportVal = root.querySelector('[data-sum-transport-value]');
    var zoneOut = root.querySelector('[data-zone-out]');
    var pscWarn = root.querySelector('[data-psc-warn]');
    var sumTotal = root.querySelector('[data-sum-total]');

    var selectedTier = null;

    /* ---------- počty ---------- */
    rows.forEach(function (row) {
      var input = row.querySelector('[data-qty]');
      row.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.step, 10);
          var max = parseInt(input.max, 10) || 40;
          var next = (parseInt(input.value, 10) || 0) + step;
          input.value = Math.max(0, Math.min(max, next));
          recalc();
        });
      });
      input.addEventListener('input', recalc);
      input.addEventListener('change', recalc);
    });

    /* ---------- pásma ---------- */
    function pickTier() {
      var count = parseInt(countInput && countInput.value, 10) || 0;
      selectedTier = null;
      tiers.forEach(function (t) {
        var from = parseInt(t.dataset.from, 10) || 0;
        var to = parseInt(t.dataset.to, 10) || 0;
        var hit = count >= from && (to <= 0 || count <= to);
        t.classList.toggle('is-active', hit && count > 0);
        if (hit && count > 0) selectedTier = t;
      });
      return count;
    }
    if (countInput) {
      countInput.addEventListener('input', recalc);
      countInput.addEventListener('change', recalc);
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!countInput) return;
        countInput.value = t.dataset.from;
        recalc();
      });
    });

    /* ---------- zóna podle PSČ ----------
       Zóna se výhradně počítá, zákazník ji nevybírá. Kdyby vybíral, klikne
       každý logicky Prahu. Dokud není PSČ celé, žádnou zónu nedosazujeme –
       jinak by se cena měnila po každé číslici. */
    function pscDigits() {
      return pscInput ? (pscInput.value || '').replace(/\D+/g, '') : '';
    }

    function zoneFromPsc() {
      if (!zoneSelect || !pscInput) return;
      var psc = pscDigits();
      if (psc.length < 5) {
        zoneSelect.value = '';
        return;
      }

      var best = null;
      var bestLen = 0;
      var fallback = null;
      Array.prototype.slice.call(zoneSelect.options).forEach(function (opt) {
        if (opt.dataset.enquiry === '1') fallback = opt;
        (opt.dataset.prefixes || '').split(',').forEach(function (p) {
          var prefix = p.trim();
          if (!prefix) return;
          if (psc.indexOf(prefix) === 0 && prefix.length > bestLen) {
            best = opt;
            bestLen = prefix.length;
          }
        });
      });

      /* PSČ, které nespadá do žádné zóny, patří k individuálnímu nacenění –
         radši poptávka než tichá doprava zdarma přes půl republiky. */
      zoneSelect.value = best ? best.value : fallback ? fallback.value : '';
    }
    if (pscInput) {
      pscInput.addEventListener('input', function () { zoneFromPsc(); recalc(); });
      pscInput.addEventListener('blur', function () { zoneFromPsc(); recalc(); });
    }

    /* ---------- přepočet ---------- */
    function currentZone() {
      if (!zoneSelect || !zoneSelect.value) return null;
      return zoneSelect.options[zoneSelect.selectedIndex];
    }

    function state() {
      var work = 0;
      var items = [];

      if (mode === 'items') {
        rows.forEach(function (row) {
          var qty = parseInt(row.querySelector('[data-qty]').value, 10) || 0;
          if (qty <= 0) return;
          work += qty * (parseInt(row.dataset.price, 10) || 0);
          items.push({ id: parseInt(row.dataset.id, 10), quantity: qty });
        });
      } else {
        var count = pickTier();
        if (selectedTier) {
          work = parseInt(selectedTier.dataset.price, 10) || 0;
          items.push({ id: parseInt(selectedTier.dataset.id, 10), quantity: 1 });
        }
        if (count > 0 && !selectedTier) {
          return { items: [], work: 0, topup: 0, transport: 0, overCount: true, zone: currentZone() };
        }
      }

      var topup = 0;
      if (minTotal > 0 && topupId && topupPrice > 0 && work > 0 && work < minTotal) {
        topup = minTotal - work;
      }

      var zone = currentZone();
      var transport = zone ? (parseInt(zone.dataset.price, 10) || 0) : 0;

      return { items: items, work: work, topup: topup, transport: transport, zone: zone, overCount: false };
    }

    function show(el, on) { if (el) el.hidden = !on; }

    /* Zóna se hledá podle prefixu, ten ale nepozná překlep: 400 00 vypadá
       stejně jako 400 01 a existuje jen to druhé. Proto ještě kontrola proti
       seznamu České pošty (assets/psc-cz.js).

       Hláška jen upozorňuje, nákup neblokuje. Seznam může zastarat a odmítnout
       objednávku kvůli nové poště by bylo horší než ji vzít a ověřit
       telefonem – což u termínu děláme tak jako tak. */
    function checkPsc() {
      if (!pscWarn) return;
      var psc = pscDigits();
      var known = typeof window.dmpPscExists !== 'function' || window.dmpPscExists(psc);
      var bad = psc.length === 5 && !known;
      pscWarn.textContent = bad ? tr('tPscUnknown', 'Takové PSČ v Česku nenajdeme. Zkontrolujte ho prosím.') : '';
      pscWarn.hidden = !bad;
    }

    /* Výpis zóny místo výběru: co jsme z PSČ vyčetli a co to znamená pro cenu. */
    function renderZone(zone) {
      if (!zoneOut) return;
      if (!zone) {
        zoneOut.textContent = zoneOut.dataset.empty || tr('tZoneByPsc', 'Spočítáme podle PSČ');
        zoneOut.classList.remove('is-set');
        return;
      }
      var label = zone.dataset.label || zone.textContent.trim();
      var price = parseInt(zone.dataset.price, 10) || 0;
      if (zone.dataset.enquiry === '1') {
        zoneOut.textContent = label;
      } else {
        var priceText = price > 0 ? money(price) : tr('tIncluded', 'v ceně');
        zoneOut.textContent = tr('tZonePrice', '[zone] — [price]')
          .replace('[zone]', function () { return label; })
          .replace('[price]', function () { return priceText; });
      }
      zoneOut.classList.add('is-set');
    }

    function recalc() {
      var s = state();
      var isEnquiry = (s.zone && s.zone.dataset.enquiry === '1') || s.overCount;

      renderZone(s.zone);
      checkPsc();

      /* U poptávky neukazujeme dílčí částky. Zákazník by si z nich složil cenu,
         kterou stejně nedostane – doprava i rozsah se teprve naceňují. */
      show(sumWork, s.work > 0 && !isEnquiry);
      if (sumWorkVal) sumWorkVal.textContent = money(s.work);

      show(sumTopup, s.topup > 0 && !isEnquiry);
      if (sumTopupVal) sumTopupVal.textContent = money(s.topup);

      /* Řádek dopravy je vidět od začátku, ať cena nevypadá kompletně dřív,
         než zákazník zadá PSČ. */
      show(sumTransport, !isEnquiry);
      if (sumTransportVal) {
        sumTransportVal.textContent = !s.zone
          ? tr('tByPsc', 'podle PSČ')
          : s.transport > 0 ? money(s.transport) : tr('tIncluded', 'v ceně');
      }

      var total = s.work + s.topup + s.transport;
      if (sumTotal) sumTotal.textContent = s.work > 0 && !isEnquiry ? money(total) : tr('tNoValue', '—');

      /* Poptávka místo košíku: mimo dojezd nebo nad rozsah ceníku. */
      if (isEnquiry) {
        setMsg(s.overCount
          ? tr('tOverCount', 'Takový rozsah naceňujeme individuálně – ozvěte se nám a připravíme nabídku na míru.')
          : tr('tFar', 'Sem běžně nevyjíždíme za pevnou cenu. Napište nám a dopravu naceníme podle vzdálenosti.'));
        show(enquiryLink, true);
        addBtn.hidden = true;
        return;
      }

      addBtn.hidden = false;
      show(enquiryLink, false);

      if (s.work <= 0) {
        setMsg('');
        addBtn.disabled = true;
        return;
      }

      /* Bez PSČ neznáme dopravu, takže by celková cena byla podstřelená. */
      if (zoneSelect && !s.zone) {
        setMsg(tr('tNeedPsc', 'Doplňte PSČ, ať k ceně připočteme dopravu.'));
        addBtn.disabled = true;
        return;
      }

      addBtn.disabled = false;
      setMsg('');
    }

    function setMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.classList.toggle('is-error', !!isError);
    }

    /* ---------- vložení do košíku ---------- */
    function properties() {
      var p = {};
      if (addrInput && addrInput.value.trim()) p['Adresa realizace'] = addrInput.value.trim();
      if (pscInput && pscInput.value.trim()) p['PSČ'] = pscInput.value.trim();
      if (dateInput && dateInput.value) p['Preferovaný termín'] = dateInput.value;
      if (phoneInput && phoneInput.value.trim()) p['Telefon'] = phoneInput.value.trim().replace(/\s+/g, ' ');
      if (noteInput && noteInput.value.trim()) p['Poznámka'] = noteInput.value.trim();
      if (mode === 'tiers' && countInput && countInput.value) p['Počet rostlin'] = countInput.value;
      return p;
    }

    function missingField() {
      if (addrInput && !addrInput.value.trim()) return { el: addrInput, text: tr('tNeedAddress', 'Doplňte prosím adresu realizace.') };
      if (pscInput && pscDigits().length < 5) return { el: pscInput, text: tr('tPscShort', 'Doplňte prosím celé PSČ, třeba 130 00.') };
      /* Select je skrytý, fokus proto patří na PSČ – z něj se zóna počítá. */
      if (zoneSelect && !zoneSelect.value) return { el: pscInput, text: tr('tPscUnknownZone', 'Tohle PSČ neznáme. Zkontrolujte ho prosím.') };
      /* 9 číslic je české číslo bez předvolby, 15 je strop mezinárodního formátu.
         Víc nekontrolujeme – slovenské i zahraniční číslo musí projít. */
      if (phoneInput && !/^\d{9,15}$/.test(phoneInput.value.replace(/[\s()+.\/-]/g, ''))) {
        return { el: phoneInput, text: tr('tNeedPhone', 'Doplňte prosím telefon, ať vám můžeme zavolat kvůli termínu.') };
      }
      return null;
    }

    /* Stejné pořadí jako v Dawn product-form.js – podle nastavení obchodu je
       v layoutu buď košíková zásuvka, nebo bublina s upozorněním. */
    function drawer() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    addBtn.addEventListener('click', function () {
      var gap = missingField();
      if (gap) {
        setMsg(gap.text, true);
        gap.el.focus();
        return;
      }

      var s = state();
      if (!s.items.length) return;

      var props = properties();
      var payload = s.items.map(function (item, i) {
        /* Údaje o realizaci stačí u prvního řádku, jinak by se opakovaly
           u každé položky v objednávce. */
        return i === 0 ? { id: item.id, quantity: item.quantity, properties: props } : item;
      });

      if (s.topup > 0 && topupId) {
        payload.push({ id: topupId, quantity: Math.round(s.topup / topupPrice) });
      }
      if (s.zone && s.zone.dataset.id && s.transport > 0) {
        payload.push({ id: parseInt(s.zone.dataset.id, 10), quantity: 1 });
      }

      var body = { items: payload };
      var cart = drawer();
      if (cart && typeof cart.getSectionsToRender === 'function') {
        /* Dawn posílá sections jako čárkou oddělený řetězec (přes FormData).
           Držíme se toho, ať se chováme přesně jako zbytek šablony. */
        body.sections = cart.getSectionsToRender().map(function (x) { return x.id; }).join(',');
        body.sections_url = window.location.pathname;
      }

      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = tr('tAdding', 'Přidávám…');

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || tr('tAddFailed', 'Nepodařilo se přidat do košíku.'));
          if (cart && typeof cart.renderContents === 'function') {
            /* Třída is-empty sedí na <cart-drawer>, ne uvnitř #CartDrawer.
               renderContents přepíše jen vnitřek, takže by třída zůstala a
               CSS by obsah zásuvky schovalo – košík by vypadal prázdný,
               dokud zákazník nedá refresh. Dawn to řeší stejně
               (assets/product-form.js). */
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          setMsg('');
        })
        .catch(function (err) {
          setMsg(err.message || tr('tAddFailedRetry', 'Nepodařilo se přidat do košíku. Zkuste to prosím znovu.'), true);
        })
        .then(function () {
          addBtn.disabled = false;
          addBtn.textContent = label;
        });
    });

    recalc();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-svc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
